<template>
    <div class="preference">
        <div class="title-heading" style="margin: 10px 0 0 20px;">
            <p>
                <i style="position: relative; top: 5px;margin-right: 5px;">
                    <img src="@/assets/titleBlock/heading1.png" alt="">
                </i>
                {{ $t("message.title.inbox") }}
                <i style="position: relative; top: 5px;margin-left: 5px;">
                    <img src="@/assets/titleBlock/heading2.png" alt="">
                </i>
            </p>
        </div>
        <div style="margin: 10px 5px">
            <el-tabs type="border-card" v-model="activeName">
                <el-tab-pane :label='$t("message.title.read")'>
                    <div>
                        <div class="search-container">
                            <el-input v-model="readedInputValue" class="search-input"
                                @keyup.enter.native="searchReadedData"></el-input>
                            <el-button class="btn btn1" icon="el-icon-search" @click="searchReadedData">
                                {{ $t("message.button.search") }}
                            </el-button>
                        </div>
                        <vxe-table ref="xTable" stripe border sortable show-header-overflow show-overflow
                            :row-config="{ isHover: true }" :data="readedData" height="630"
                            @cell-click="readedTableDBClick">
                            <vxe-column type="seq" :title='$t("message.table.SN")' width="150"></vxe-column>
                            <vxe-column field="subject" :title='$t("message.table.theme")' sortable></vxe-column>
                            <vxe-column field="inboxType" :title='$t("message.table.type")' sortable
                                :filters="readedInboxTypeList"></vxe-column>
                            <!-- <vxe-column field="sender" :title='$t("message.table.sender")' sortable
                                :filters="readedSenderList"></vxe-column> -->
                            <vxe-column field="sentAt" :title='$t("message.table.sentTime")' sortable></vxe-column>
                        </vxe-table>
                    </div>
                </el-tab-pane>

                <el-tab-pane name="first">
                    <template slot="label">
                        <span class="tab-label-wrapper">
                            {{ $t("message.title.unread") }}
                            <span v-if="readCount > 0" class="corner-badge" :class="{ 'has-count': readCount > 0 }">
                                {{ readCount > 99 ? '99+' : readCount }}
                            </span>
                        </span>
                    </template>
                    <div>
                        <div class="search-container">
                            <el-input v-model="unReadedInputValue" class="search-input"
                                @keyup.enter.native="searchUnReadedData"></el-input>
                            <el-button class="btn btn1" icon="el-icon-search" @click="searchUnReadedData">
                                {{ $t("message.button.search") }}
                            </el-button>
                        </div>
                        <vxe-table ref="yTable" stripe border show-header-overflow show-overflow
                            :row-config="{ isHover: true }" :data="unReadedData" height="630"
                            @cell-click="unReadedDBClick">
                            <vxe-column type="seq" :title='$t("message.table.SN")' width="150"></vxe-column>
                            <vxe-column field="subject" :title='$t("message.table.theme")' sortable></vxe-column>
                            <vxe-column field="inboxType" :title='$t("message.table.type")' sortable
                                :filters="unReadedInboxTypeList"></vxe-column>
                            <!-- <vxe-column field="sender" :title='$t("message.table.sender")' sortable
                                :filters="unReadedSenderList"></vxe-column> -->
                            <vxe-column field="sentAt" :title='$t("message.table.sentTime")' sortable></vxe-column>
                        </vxe-table>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div>
            <el-dialog class="custom-dialog" :title='$t("message.title.readEmails")' :visible.sync="dialogVisible"
                width="70%" custom-class="custom-dialog">
                <div v-html="content" @click="handleClick"></div>
            </el-dialog>
            <el-dialog class="custom-dialog" :title='$t("message.title.unreadEmails")' :visible.sync="unDialogVisible"
                width="70%" custom-class="custom-dialog">
                <div v-html="unContent" @click="handleClick"></div>
            </el-dialog>
        </div>
    </div>
</template>


<script>
import axios from "axios";
import { EventBus } from './eventBus'
export default {
    data() {
        return {
            activeName: 'first',
            readCount: 0,
            readedInputValue: '',
            unReadedInputValue: '',
            readedData: [],
            unReadedData: [],
            readedBaseData: [],
            unReadedBaseData: [],
            dialogVisible: false,
            unDialogVisible: false,
            content: '',
            unContent: '',
            readedSenderList: [],
            readedInboxTypeList: [],
            unReadedSenderList: [],
            unReadedInboxTypeList: [],
        };
    },
    components: { EventBus },
    mounted() { },
    created() {
        this.getInBoxInfo();
    },
    methods: {
        async getInBoxInfo() {
            try {
                const session = JSON.parse(window.sessionStorage.getItem("userContext") || '{}');
                if (!session?.id) return;

                const API_ENDPOINT = "/pmdm/ObjectCommon/getInboxByUser";

                const { data } = await axios.post(API_ENDPOINT, { userId: session.id });

                if (data.code !== 200) return

                const processMessages = (messages) =>
                    messages.map(msg => ({
                        id: msg.id,
                        inboxType: msg.inboxType,
                        isRead: msg.isRead,
                        // sender: msg.sender,
                        sentAt: msg.sentAt,
                        subject: msg.subject,
                        content: msg.content
                    }));

                this.readedData = processMessages(data.object?.readed || []);
                this.unReadedData = processMessages(data.object?.unreaded || []);

                this.readedBaseData = this.readedData;
                this.unReadedBaseData = this.unReadedData;

                this.readCount = this.unReadedData.length;

                const getUniqueOptions = (data, key) => {
                    const seen = new Set();
                    return data.filter(item => {
                        const val = item[key];
                        if (seen.has(val)) return false;
                        seen.add(val);
                        return true;
                    }).map(item => ({
                        label: item[key],
                        value: item[key]
                    }));
                };

                const readedOptions = {
                    // sender: getUniqueOptions(this.readedBaseData, 'sender'),
                    inboxType: getUniqueOptions(this.readedBaseData, 'inboxType')
                };

                const unReadedOptions = {
                    // sender: getUniqueOptions(this.unReadedBaseData, 'sender'),
                    inboxType: getUniqueOptions(this.unReadedBaseData, 'inboxType')
                };

                const setTableFilters = (tableRef, filters) => {
                    Object.entries(filters).forEach(([key, options]) => {
                        tableRef.setFilter(key, options);
                    });
                };

                setTableFilters(this.$refs.xTable, readedOptions);
                setTableFilters(this.$refs.yTable, unReadedOptions);


            } catch (error) {
                console.error("收件箱数据获取失败:", {
                    message: error.message,
                    response: error.response?.data,
                    config: error.config
                });
            }
        },
        handleClick(event) {
            const target = event.target.closest('a.dynamic-link');
            if (target) {
                const { id = '', classId = '', subClassId = '', name: title = '' } = target.dataset;

                const params = { id, classId, subClassId, title };

                console.log('[参数捕获] 20240314', JSON.stringify(params, null, 2));

                this.getLink({ id, classId, subClassId, title });
            }

        },
        readedTableDBClick(row) {
            this.content = row.row.content;
            this.dialogVisible = true;
        },
        async unReadedDBClick(row) {
            try {
                const API_ENDPOINT = "/pmdm/ObjectCommon/getInboxById";
                this.unContent = row.row.content;
                this.unDialogVisible = true;

                const { data } = await axios.post(API_ENDPOINT, { inboxId: row.row.id });
                if (data.code === 200) {
                    this.$message({
                        showClose: true,
                        message: this.$t('message.success.emailRead'),
                        type: 'success',
                        duration: 3000
                    });
                    const payload = '1';
                    EventBus.$emit('trigger-method', payload)
                    await this.getInBoxInfo();
                } else {
                    console.error("邮件操作失败:", error);
                    this.$message({
                        showClose: true,
                        message: error.response?.data?.message || '邮件操作失败，请稍后重试',
                        type: 'error',
                        duration: 3000
                    });
                }
            } catch (error) {
                console.error('邮件操作失败:', error);
            }
        },
        searchReadedData() {
            const query = this.readedInputValue.trim().toLowerCase();
            if (!query) {
                this.readedData = [...this.readedBaseData]
                return
            }
            this.readedData = this.readedBaseData.filter(item => {
                return item.subject && String(item.subject).toLowerCase().includes(query.toLowerCase())
            });
        },
        searchUnReadedData() {
            const query = this.unReadedInputValue.trim().toLowerCase();
            if (!query) {
                this.unReadedData = [...this.unReadedBaseData]
                this.readCount = this.unReadedData.length
                return
            }
            this.unReadedData = this.unReadedBaseData.filter(item => {
                return item.subject && String(item.subject).toLowerCase().includes(query.toLowerCase())
            });

            this.readCount = this.unReadedData.length;
        }
    }
};
</script>

<style scoped>
.preference {
    width: 100%;
    height: 800px;
    background: #fff;
    overflow: hidden;
    overflow-y: auto;
}

.title-heading p {
    font-size: 18px;
    font-weight: 500;
    margin: 0;
}

.el-tabs.el-tabs--border-card>>>.el-tabs__header .el-tabs__item {
    border-radius: 0 0 0 0 !important;
    border-left: 0px !important;
    min-width: 100px;
    text-align: center;
}

.tab-label-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
    padding-right: 24px;
}

.corner-badge {
    position: absolute;
    right: 0px;
    top: 4px;
    min-width: 16px;
    height: 16px;
    line-height: 16px;
    padding: 0 4px;
    background: #f56c6c;
    color: white;
    border-radius: 8px;
    font-size: 12px;
    text-align: center;
    transform-origin: 100% 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.corner-badge.has-count {
    min-width: 20px;
    padding: 0 2px;
}

.search-container {
    display: flex;
    gap: 8px;
    max-width: 600px;
    margin-bottom: 5px;
}

.search-input {
    flex-grow: 1;
    min-width: 200px;
}

::v-deep .custom-dialog .el-dialog__body {
    padding: 0 20px;
}

.el-tabs.el-tabs--border-card>>>.el-tabs__header .el-tabs__item:not(.is-active) {
    color: #000000 !important;
}

::v-deep .vxe-table--render-default .vxe-table--empty-content {
    display: none !important;
}

::v-deep .custom-dialog .el-dialog {
    min-height: 500px;
}

::v-deep .custom-dialog .el-dialog__body {
    min-height: 400px;
    overflow-y: auto;
}
</style>